// extracted by mini-css-extract-plugin
module.exports = {"SortComponent_container":"SortComponent_SortComponent_container__El27e","InputSelect_select":"SortComponent_InputSelect_select__2vcXq"};